import type { Box, Camera } from "./geometry";
import type { Point } from "../scene/model";

export const minimumZoom = 0.1;
export const maximumZoom = 5;
export const clampZoom = (zoom: number) =>
  Math.max(minimumZoom, Math.min(maximumZoom, zoom));
export function stepZoom(zoom: number, direction: number) {
  return clampZoom(Math.round((zoom + direction * 0.1) * 1000) / 1000);
}
export function zoomAt(camera: Camera, zoom: number, point: Point) {
  zoom = clampZoom(zoom);
  const ratio = zoom / camera.zoom;
  camera.x = point.x - (point.x - camera.x) * ratio;
  camera.y = point.y - (point.y - camera.y) * ratio;
  camera.zoom = zoom;
}
export function resetViewport(
  camera: Camera,
  area: Box,
  page: { width: number; height: number },
) {
  camera.zoom = 1;
  camera.x = area.x + (area.width - page.width) / 2;
  camera.y = area.y + (area.height - page.height) / 2;
}
